import { render, staticRenderFns } from "./payment_component.vue?vue&type=template&id=60e9814b&"
import script from "./payment_component.vue?vue&type=script&lang=js&"
export * from "./payment_component.vue?vue&type=script&lang=js&"
import style0 from "./payment_component.vue?vue&type=style&index=0&id=60e9814b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports